<button (click)="loginSportsAlliance()" class="btn btn-primary btn-block font-size-14 w-100 fw-bold">
  {{ 'login.button' | translate }}
</button>

<div class="mt-1">
  <fgbcl-errors></fgbcl-errors>
</div>
